export type CacheBridgeFailureContext = {
	bridge: 'fragment' | 'mutation' | 'query';
	operation: 'read' | 'write';
	targetCache: 'apollo' | 'relay';
};

export type CacheBridgeFailureDiagnosticContext = CacheBridgeFailureContext & {
	impact: string;
	action: string;
};

export type CacheBridgeFailureDiagnostic = CacheBridgeFailureDiagnosticContext & {
	message: string;
	error: unknown;
};

export type CacheBridgeFailureReporter = {
	reportFailure: (diagnostic: CacheBridgeFailureDiagnostic) => void;
};

function getConsoleWarnArgs(diagnostic: CacheBridgeFailureDiagnostic) {
	const { message, error, ...diagnosticContext } = diagnostic;

	return [message, diagnosticContext, error] as const;
}

const consoleWarnCacheBridgeFailureReporter: CacheBridgeFailureReporter = {
	reportFailure: (diagnostic) => {
		const [message, diagnosticContext, error] = getConsoleWarnArgs(diagnostic);

		// eslint-disable-next-line no-console -- cache bridge failures are degraded-mode fallbacks and should remain visible without introducing a monitoring dependency.
		console.warn(message, diagnosticContext, error);
	},
};

// Dependency inversion point: bridge diagnostics depend on the reporter
// interface above, while the concrete observability transport is chosen here.
// If cache bridge warnings move into production monitoring later, wire an
// @confluence/monitoring-backed reporter here instead of changing bridge callers.
const cacheBridgeFailureReporter: CacheBridgeFailureReporter =
	consoleWarnCacheBridgeFailureReporter;

export function reportCacheBridgeFailureDiagnostic(diagnostic: CacheBridgeFailureDiagnostic): void {
	cacheBridgeFailureReporter.reportFailure(diagnostic);
}
